/**
 * Walking is not a setting any more (issue walk-bake#11, C14): a step that would leave the floor
 * may be turned up to 75 degrees to glide along the edge, because 75 is the smoothest. Old saved
 * choices (`walk-player.walking`) are never read. Only the Player's own `?slide=` stays, for tests.
 */

export const FIXED_SLIDE_DEG = 75;

/** What `?slide=` accepts (degrees; 0 = off, the old behaviour). */
const TEST_SLIDE_OPTIONS = [0, 30, 45, 60, 75];

/** The slide limit: 75, or `?slide=` in the Player's own URL (for tests; not saved). */
export function slideWithUrlOverride(search: string): number {
  const value = new URLSearchParams(search).get("slide");
  const degrees = value === null || value === "" ? NaN : Number(value);
  return TEST_SLIDE_OPTIONS.includes(degrees) ? degrees : FIXED_SLIDE_DEG;
}
